export default "__VITE_ASSET__DJh9UJJm__"